var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head-nav-bar',{attrs:{"title":_vm.title,"fixed":true}}),_c('div',{staticClass:"report-box"},[_c('iframe',{ref:"iframe",staticStyle:{"height":"calc(100vh - 50px)","width":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }